<template>
  <v-dialog v-model="dialog" width="850">
    <template v-slot:activator="{}">
      <BaseButton
        :text="localStorage.translations.pages['setting-personal_area'].buttons['dobavit-adres']"
        @click="openModal"
        default_icon="button-add"
      />
    </template>
    <ContactAdressAddModalBody
      v-if="dialog"
      :closeModal="closeModal"
      :page="page"
      :limit="limit"
      @addAddress="addAddress"
    />
  </v-dialog>
</template>

<script>
import ContactAdressAddModalBody from 'components/personalArea/ContactAdressAddModalBody'
export default {
  name: 'ContactAdressAddModal',
  props: ['toName', 'page', 'limit'],
  components: { ContactAdressAddModalBody },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    addAddress(data) {
      this.$emit('addAddress', data)
    },
  },
}
</script>
